import * as api from "./adapter";

export default {
  /**
   * getCrewingAgents
   * @returns {Promise<*>}
   */
  index: async ({ pagination, sort, filter, search }) =>
    await api.read("crewing_agents", {
      query: {
        filter: { name: search, ...filter },
        sort: `${sort.direction === "asc" ? "" : "-"}${sort.field}`,
        page: { size: pagination.itemsPerPage, number: pagination.current },
      },
    }),
  /**
   * getCrewingAgentDetails
   * @param {string} id
   * @returns {Promise<*>}
   */
  show: async (id) => await api.read(`crewing_agents/${id}`),
};
